<template>
  <div class="card flex items-center mb-5 space-x-5">
    <div class="w-14 shrink-0">
      <img
        src="/img/icons/svg/pine tree.svg"
        alt="Pine tree"
        class="w-full"
      >
    </div>
    <div>
      <h2 class="mb-2 text-lg leading-snug text-gray-600">
        You planted <b class="text-gray-900">{{ Math.floor(achievements.number_of_planted_trees) }}&nbsp;tree(s)</b> so far.
      </h2>
    </div>
  </div>
</template>
<script>
export default {
  name: "v-achievements-planted-trees",
  props: {
    achievements: {
      type: Object,
      required: true
    }
  }
};
</script>
